// extracted by mini-css-extract-plugin
module.exports = {"el":"index-module--el--NnQIF","contact":"index-module--contact--ahQJK"};